import { Dialog, DialogActions, DialogContent,  DialogTitle, FormControl, InputLabel, Select, TextField, MenuItem } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { Component } from 'react';
import Constants from '../Constants';

export default class SaveSourceDialog extends Component {
    static displayName = SaveSourceDialog.name;

    constructor(props) {
        super(props);
        this.state = {            
            errors: [],
            source: props.source
        };
    }

    handleInputChange = (e) => {
        e.persist();
        this.updateSourceState(e.target.name, e.target.value);
    }

    updateSourceState = (propName, value) => {
        this.setState((state) => {
            return {
                source: {   
                    ...state.source, [propName]: value
                }
            }
        });
    }

    isValidSourceType = () => Constants.isKnownSourceType(this.state.source.sourceTypeNew)

    getSourceTypeOptions = () => {
        const options = Constants.SourceTypes.map(t => ({ ...t }));

        if (this.props.isUpdate && Constants.isLegacySourceType(this.props.source.sourceTypeNew)) {
            const legacyType = Constants.LegacySourceTypes.find(t => t.apiValue === this.props.source.sourceTypeNew);
            if (legacyType) {
                options.unshift({ ...legacyType, disabled: true });
            }
        }

        return options;
    }

    getNormalizedSource = () => ({
        ...this.state.source,
        sourceType: Constants.getSourceTypeId(this.state.source.sourceTypeNew),
        maintainer: this.state.source.maintainer?.trim() ?? ''
    })

    validateSource = () => {
        var errors = [];
        const { maintainer } = this.getNormalizedSource();
        if (!maintainer) {
            errors.push('Maintainer is required. Please select a maintainer from the list.');
        } else if (!Constants.Maintainers.some(m => m.id === maintainer)) {
            errors.push('Please select a valid maintainer from the list.');
        }

        if (!this.state.source.sourceTypeNew) {
            errors.push('Source Type is required. Please select a source type from the list.');
        } else if (Constants.isLegacySourceType(this.state.source.sourceTypeNew)) {
            errors.push('Legacy source types are no longer supported. Please select a new source type from the list.');
        } else if (!this.isValidSourceType()) {
            errors.push('Please select a valid source type from the list.');
        }

        if (!this.props.isUpdate) {
            if (this.state.source.id && this.props.sources.find(s => s.id?.toString() === this.state.source.id)) {
                errors.push(`Source with id ${this.state.source.id} already exists`);
            }
            if (this.props.sources.find(s => s.name === this.state.source.name)) {
                errors.push(`Source with name ${this.state.source.name} already exists`);
            }
        }

        return errors;
    }

    saveSource = async (e) => {
        e.preventDefault();

        var errors = this.validateSource();
        this.setState({ errors: errors });
        if (errors.length !== 0) {
            return;
        }

        this.props.onSaveClick();
        var endpoint = this.props.isUpdate ? `api/sources/${this.state.source.id}` :  'api/sources';
        var method = this.props.isUpdate ? 'PUT' : 'POST';
        const sourceToSave = this.getNormalizedSource();

        var response = await fetch(endpoint, {
            method: method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sourceToSave)
        });

        if (response.status === 200) {
            let data = await response.json();
            if (this.props.isUpdate) {
                this.props.onSuccessfullUpdate(data);
            }
            else {
                this.props.onSuccessfullCreate(data);
            }
        }
        else {
            this.props.onFailedSave();
        }
    }

    render() {
        return (
            <Dialog open={this.props.open} onClose={this.props.onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title" style={{paddingBottom:0}}>{this.props.isUpdate ? "Update Source" : "Create Source"}</DialogTitle>
                {this.state.errors.map(e => (<Alert key={e} severity="error">{e}</Alert>))}
                <form onSubmit={this.saveSource}>
                    <DialogContent style={{ paddingTop: 5 }}>
                        <FormControl fullWidth>
                            <TextField
                                margin="dense"
                                label="Id"
                                type="number"
                                name="id"
                                value={this.state.source.id ?? ''}
                                onChange={this.handleInputChange}
                                hidden={!this.props.isUpdate}
                                disabled={true}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <TextField
                                margin="dense"
                                label="Name"
                                type="text"
                                name="name"
                                value={this.state.source.name ?? ''}
                                disabled={this.props.isUpdate}
                                onChange={this.handleInputChange}
                                required
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="source-type">Source Type</InputLabel>
                            <Select
                                name="sourceTypeNew"
                                value={this.state.source.sourceTypeNew ?? ''}
                                onChange={this.handleInputChange}
                                inputProps={{
                                    name: 'sourceTypeNew',
                                    id: 'source-type',
                                }}
                                required
                            >
                                <MenuItem value="" />
                                {this.getSourceTypeOptions().map(t => (<MenuItem key={t.apiValue ?? t.id} value={t.apiValue} disabled={t.disabled}>{t.name}</MenuItem>))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="has-inplay">Has In-Play</InputLabel>
                            <Select
                                name="hasInPlay"
                                value={this.state.source.hasInPlay ? this.state.source.hasInPlay : ''}
                                onChange={this.handleInputChange}
                                inputProps={{
                                    name: 'hasInPlay',
                                    id: 'has-inplay',
                                }}
                                required
                            >
                                <MenuItem value="" />
                                {Constants.AvailabilityTypes.map(t => (<MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="has-prematch">Has Pre-Match</InputLabel>
                            <Select
                                name="hasPreMatch"
                                value={this.state.source.hasPreMatch ? this.state.source.hasPreMatch : ''}
                                onChange={this.handleInputChange}
                                inputProps={{
                                    name: 'hasPreMatch',
                                    id: 'has-prematch',
                                }}
                                required
                            >
                                <MenuItem value="" />
                                {Constants.AvailabilityTypes.map(t => (<MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="has-markets">Has Markets</InputLabel>
                            <Select
                                name="hasMarkets"
                                value={this.state.source.hasMarkets ? this.state.source.hasMarkets : ''}
                                onChange={this.handleInputChange}
                                inputProps={{
                                    name: 'hasMarkets',
                                    id: 'has-markets',
                                }}
                                required
                            >
                                <MenuItem value="" />
                                {Constants.AvailabilityTypes.map(t => (<MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="maintainer">Maintainer</InputLabel>
                            <Select
                                name="maintainer"
                                value={this.state.source.maintainer?.trim() ?? ''}
                                onChange={this.handleInputChange}
                                inputProps={{
                                    name: 'maintainer',
                                    id: 'maintainer',
                                }}
                                required
                            >
                                <MenuItem value="" />
                                {Constants.Maintainers.map(m => (<MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions style={{padding:'16px 24px'}}>
                        <button type="button" className="btn btn-danger" onClick={this.props.onCloseClick}>
                            Cancel
                        </button>
                        <input type="submit" className="btn btn-primary" value={this.props.isUpdate ? "Update" : "Create"} />
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}
